import React from 'react';
import './css/PlayersStatsLoader.css';

// This component renders a skeleton loader for player stats.
function PlayerStatsLoader() {
  return (
    <div className='player-stats-skeleton-grid'>
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={index} className="skeleton-box"></div>
      ))}
    </div>
  );
}

export default PlayerStatsLoader;